<template>
  <div>
    <CandidateLayout>
      <div v-if="!isJobConcluded">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12 col-12">
              <div class="row align-items-center mt-3">
                <div class="col-2"></div>
                <div class="col-8 text-center">
                  <img
                    alt="Jovool Logo"
                    src="/images/Jovool_logo.png"
                    style="width: 120px"
                  />
                </div>
                <div class="col-2"></div>
              </div>

              <div v-if="!isJobConcluded || job.uid !== '3xw0ptkh'" class="row">
                <div class="col-lg-3 col-12"></div>
                <div class="col-lg-6 col-12">
                  <transition apper mode="out-in" name="fade">
                    <StepIndicator
                      v-if="!step_final"
                      :current="setup_index"
                      :currentColor="'#00a0d6'"
                      :total="total_steps"
                      class="mt-3"
                      defaultColor="#53358b"
                    ></StepIndicator>
                  </transition>
                  <a
                    v-if="show_back_arrow"
                    style="cursor: pointer; font-size: 2rem; color: #53358b"
                    @click="goBack"
                    >&larr;<small style="font-size: 18px">Voltar</small>
                  </a>
                </div>
              </div>
              <transition appear mode="out-in" name="fade">
                <Register
                  v-if="step_register"
                  :account_uid="account_uid"
                  :apply="apply"
                  :candidate_data="candidate"
                  :extra_options="extra_options"
                  :job="job"
                  :mandatory_questions="mandatory_questions"
                  :selective_process="selective_process"
                />

                <DataCollect
                  v-if="step_data_collect"
                  :selective_process_uid="selective_process_uid"
                />

                <Experience
                  v-if="step_historical"
                  :candidate_data="candidate"
                  :job="job"
                />
                <ConfirmExperience
                  v-if="step_confirm"
                  :account_uid="account_uid"
                  :job="job"
                />
                <div v-if="step_videos">
                  <div
                    v-if="
                      evaluations && show_evaluation && evaluations.length > 0
                    "
                  >
                    <Evaluations
                      :account_uid="account_uid"
                      :candidate="candidate"
                      :evaluations="evaluations"
                      :selective_process_uid="selective_process_uid"
                      class="mt-2"
                    />
                  </div>
                  <Questions
                    v-if="step_videos && !show_evaluation"
                    :account_uid="account_uid"
                    :job_questions="questions"
                    :selective_process_uid="selective_process_uid"
                    class="mt-2"
                  />
                </div>
                <div
                  v-if="step_bigfive"
                  class="card card-body mt-2 text-dark bg-white"
                  style="height: 100%; overflow: scroll; overflow-x: hidden"
                >
                  <Bigfive
                    :account_uid="account_uid"
                    :amount_itens="bigfive.amount_itens"
                    :bigfive_uid="bigfive.uid"
                    :candidate_uid="candidate_uid"
                    :no_next="false"
                  />
                </div>

                <Congratulation
                  v-if="step_final"
                  :account_uid="account_uid"
                  :job="job"
                  :label="congratulation_label"
                  :show="false"
                  class="mt-3"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </CandidateLayout>
  </div>
</template>

<script>
import { email, minLength, required } from "vuelidate/lib/validators";
import StepIndicator from "vue-step-indicator";
import Register from "@/Candidates/Applies/Register.vue";
import DataCollect from "@/Candidates/Applies/DataCollect.vue";
import Experience from "@/Candidates/Applies/Experience.vue";
import ConfirmExperience from "@/Candidates/Applies/ConfirmExperience.vue";
import Evaluations from "@/Candidates/Applies/Evaluations.vue";
import Questions from "@/Jobs/Questions.vue";
import Bigfive from "@/Bigfives/Test.vue";
import Congratulation from "@/Jobs/Congratulation.vue";
import CandidateLayout from "layouts/Candidate.vue";

export default {
  props: [
    "job_uid",
    "account_uid",
    "job_link",
    "job",
    "apply",
    "evaluations",
    "questions",
    "mandatory_questions",
    "candidate_uid",
    "bigfive",
    "candidate",
    "selective_process",
    "selective_process_uid",
    "extra_options",
    "talent_pixel_tracker",
    "custom_final_message",
  ],
  components: {
    DataCollect,
    StepIndicator,
    Register,
    Experience,
    Evaluations,
    Questions,
    Bigfive,
    Congratulation,
    ConfirmExperience,
    CandidateLayout,
  },
  data: () => ({
    load: false,
    error_linkedin: false,
    step_register: true,
    step_data_collect: false,
    step_historical: false,
    step_confirm: false,
    step_videos: false,
    step_bigfive: false,
    step_final: false,
    setup_index: 0,
    total_steps: 3,
    show_evaluation: true,
    show_evaluation_introduction: true,
    congratulation_label: null,
    user: {
      email: "",
      name: "",
      password: "",
      accept_terms: false,
    },
  }),
  mounted() {
    if (this.questions?.length > 0) {
      this.show_evaluation = false;
    }
    document.body.classList.add("body_sign_up_grey");
    if (this.job.bigfive !== false) {
      this.total_steps = 4;
    }

    eventBus.$on("RegisterFinished", () => {
      this.disableSteps();
      this.setup_index = 1;
      if (this.job.hide_upload_cv && !this.job.ask_remuneration) {
        eventBus.$emit("ExperiencieFinished");
        return;
      }

      this.step_historical = true;
    });

    eventBus.$on("DataCollecFinished", () => {
      this.disableSteps();
      this.step_data_collect = true;
    });

    eventBus.$on("ExperiencieFinished", () => {
      this.disableSteps();
      this.setup_index = 1;
      if (this.job.hide_confirm_experiences) {
        eventBus.$emit("ConfirmFinished");
        return;
      }

      this.step_confirm = true;
    });

    eventBus.$on("ConfirmFinished", () => {
      this.disableSteps();
      this.setup_index = this.total_steps - 1;
      if (this.job.allow_unlimited_chances) {
        this.candidate.view_evaluation = 0;
      }
      if (this.candidate.view_evaluation <= 2) {
        if (this.questions?.length > 0 || this.evaluations?.length > 0) {
          this.congratulation_label = this.evaluations?.length
            ? this.custom_final_message !== ""
              ? this.custom_final_message
              : "Concluído com sucesso"
            : null;
          this.step_videos = true;
          return;
        }
        if (this.bigfive !== 0) {
          this.setup_index = 3;
          this.step_bigfive = true;
          return;
        }
        this.step_final = true;
      } else {
        if (this.bigfive !== 0) {
          this.setup_index = 3;
          this.step_bigfive = true;
          return;
        }
        this.step_final = true;
      }
    });

    eventBus.$on("finalScreen", () => {
      if (this.evaluations.length > 0 && !this.show_evaluation) {
        this.show_evaluation = true;
        return;
      }
      this.disableSteps();
      if (this.bigfive !== 0) {
        this.setup_index = 3;
        this.step_bigfive = true;
      } else {
        this.step_final = true;
      }
    });

    eventBus.$on("gotoFinal", () => {
      this.disableSteps();
      this.step_final = true;
    });

    eventBus.$on("RegisterFinished", () => {
      this.triggerTalentPixelSync("apply_start");
    });

    eventBus.$on("ExperiencieFinished", () => {
      this.triggerTalentPixelSync("apply_submit");
    });

    eventBus.$on("ConfirmFinished", () => {
      this.triggerTalentPixelSync("apply_submit");
    });

    // if (this.apply.completed) {
    //   this.disableSteps();
    //   this.setup_index = 1;
    //   this.step_confirm = true;
    // }
  },
  methods: {
    goBack() {
      if (this.step_bigfive) {
        this.disableSteps();
        if (this.questions?.length > 0 || this.evaluations?.length > 0) {
          this.step_videos = true;
          this.setup_index = this.total_steps - 1;
        } else {
          this.step_confirm = true;
          this.setup_index = 1;
        }
        return;
      }

      if (this.step_videos) {
        this.disableSteps();
        this.step_confirm = true;
        this.setup_index = 1;
        return;
      }

      if (this.step_confirm) {
        this.disableSteps();
        if (this.job.hide_upload_cv && !this.job.ask_remuneration) {
          this.step_register = true;
          this.setup_index = 0;
        } else {
          this.step_historical = true;
          this.setup_index = 1;
        }
        return;
      }

      if (this.step_historical) {
        this.disableSteps();
        this.step_register = true;
        this.setup_index = 0;
      }
    },
    triggerTalentPixelSync() {
      if (!this.talent_pixel_tracker) {
        return;
      }

      let talentPixelWrapper = document.createElement("p");
      let talentPixel = document.createElement("IMG");
      let providedURL = `https://www.talent.com/tracker/img-pixel.php?tracker=${this.talent_pixel_tracker}`;

      talentPixel.setAttribute("src", providedURL);
      talentPixelWrapper.appendChild(talentPixel);
      document.body.appendChild(talentPixelWrapper);
    },
    disableSteps() {
      this.step_register = false;
      this.step_data_collect = false;
      this.step_historical = false;
      this.step_confirm = false;
      this.step_videos = false;
      this.step_bigfive = false;
      this.step_final = false;
    },
    destroySession() {
      axios
        .delete(
          "/candidates/sessions?job_uid=" +
            this.job.uid +
            "&account_uid=" +
            this.account_uid
        )
        .then(() => {
          location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    show_back_arrow() {
      return this.step_historical || this.step_confirm;
    },
    isJobConcluded() {
      const date = new Date();
      const conclution_date = new Date(this.job.date_conclusion);
      let candidate_created_at = new Date(this.candidate.created_at);
      if (date > conclution_date && candidate_created_at > conclution_date) {
        this.destroySession();
        return true;
      } else {
        return false;
      }
    },
  },
  validations: {
    user: {
      email: { required, email },
      name: { required },
      password: { required, minLength: minLength(6) },
    },
  },
};
</script>

<style>
body {
  height: 100%;
  margin: 0;
}
</style>
